import React from 'react'
import { connect } from 'react-redux'
import injectSheet from 'react-jss'
import style from './exportStyle'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import ConfigurationSummary from 'components/DoorEntityConfigurationSummary'
import ConfigurationDetails from './ConfigurationDetails'
import DescriptionBuilder from 'components/DeviceDescription/DescriptionBuilder'
import { exportWireDistanceSelector, currentDoorSelector, doorDoorControllerSelector } from 'selectors/components'

const mapStateToProps = state => {
  const distanceResult = exportWireDistanceSelector(state)

  return {
    currentDoor: currentDoorSelector(state),
    doorController: doorDoorControllerSelector(state),
    wireDistance: distanceResult && distanceResult.distance
  }
}

const DoorExportDetails = ({ currentDoor, doorController, wireDistance, classes }) =>
  <div className={classes.details}>
    <div className={classes.col}>
      <div className={classes.wiringInfo}>
        <strong>Door Controller Connection:</strong>
        <span className={classes.row}>
          <div
            className={classes.doorControllerIcon}
            style={{ background: doorController.color }}
          >
            <FontAwesomeIcon icon={['far', 'microchip']} style={{ margin: 'auto' }} />
          </div>
          { doorController.name }
        </span>
        <span>
          Length: { wireDistance }
        </span>
      </div>
      <ConfigurationSummary isExport />
      <DescriptionBuilder currentDevice={currentDoor} type='door' isExport addPadding />
    </div>
    <div className={classes.col}>
      <ConfigurationDetails isExport />
    </div>
  </div>

export default connect(mapStateToProps)(injectSheet(style)(DoorExportDetails))



// WEBPACK FOOTER //
// ./src/components/DoorDetails/exportDetails.js